import Parse from 'html-react-parser';

function BMP20243(props) {
    let svgCode =
    `<svg width="1800" height="628" viewBox="0 0 1800 628" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    .boxStyle rect {
        ${props.boxStyle}
    }
    ${props.fontFace}
    </style>
    <g class="boxStyle">
        <rect width="1800" height="628" fill="${props.backgroundFill}"/>
        <rect x="1754" y="56" width="36" height="572" fill="${props.paramFill}"/>
        <rect x="2" y="2" width="1796" height="48" fill="${props.paramFill}"/>
        <g fill="${props.fontColour}" font-family="${props.fontName}" font-weight="${props.fontExtras.weight}" letter-spacing="${props.fontExtras.space}">
        <text font-size="17"><tspan x="66" y="33.8105">SOURCE</tspan></text>
        <text font-size="17"><tspan x="206" y="33.8105">CURVE</tspan></text>
        <text font-size="17"><tspan x="414" y="33.8105">AMOUNT</tspan></text>
        <text font-size="17"><tspan x="744" y="33.8105">DESTINATION</tspan></text>
        <text font-size="17"><tspan x="992" y="33.8105">TYPE</tspan></text>
        <text font-size="17"><tspan x="1091" y="33.8105">MOD</tspan></text>
        <text font-size="17"><tspan x="1210" y="33.8105">AUX SOURCE</tspan></text>
        <text font-size="17"><tspan x="1376" y="33.8105">CURVE</tspan></text>
        <text font-size="17"><tspan x="1559" y="33.8105">OUTPUT</tspan></text>
        </g>
        <path d="M1769 34L1778.53 22H1759.47L1769 34Z" fill="${props.fontColour}"/>
    </g>
    </svg>`

    props.svgReturn(79, svgCode, "bmp00243", 1800, 628);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20243;